import React from "react";
import style from "./UploadDocument.module.css";
import CustomSelect from "../../../../CommonComponents/Select/CustomSelect";
import { images } from "../../../../Images/Svg";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useState } from "react";
import { useEffect } from "react";
import CommonButton from "../../../../CommonComponents/CommonButton";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  clearDocumentUopload,
  deleteFile,
  documentUploadReducer,
} from "../../../../Redux/Slice/documentSlice";
import Loader from "../../../../CommonComponents/Loader/Loader";
import useToaster from "../../../../customHook/useToaster";
import { isLoadingStateReducer } from "../../../../Redux/Slice/loginSlice";
import { uploadDocument } from "../../../../Services/upload.service";
import { uploadOptions } from "../../../../constants/utils";
import { truncateMiddleText } from "../../../../Utils/helper";

const { AodbeIcon, CancelIcon } = images;
const UploadDocument = ({ onSuccess = () => {} }) => {
  const [uploadDocumentList, setUploadDocumentList] = useState({});
  const [selectedValueUpload, setSelectedValueUpload] = useState("");
  const documentUpload = useSelector(
    (state) => state.documentSlice.documentUpload
  );
  const caseId = useSelector((state) => state?.CaseDescriptionSlice?.caseId);

  const label = "Type of Document";
  const { showToast } = useToaster();
  // const fileConverter = async (filesData) => {
  //   let convertedFiles = [];
  //   for (const fileData of filesData) {
  //     const { fileUrl, fileName } = fileData;
  //     const file = await fetch(fileUrl)
  //       .then((res) => res.blob())
  //       .then((blob) => new File([blob], fileName, { type: blob.type }));

  //     convertedFiles.push(file);
  //   }

  //   return convertedFiles;
  // };

  const fileConverter = async (filesData) => {
    let convertedFiles = [];
    for (const fileData of filesData) {
      const { fileUrl, fileName } = fileData;
      const file = await fetch(fileUrl)
        .then((res) => res.blob())
        .then((blob) => new File([blob], fileName, { type: blob.type }));

      convertedFiles.push(file);
    }

    return convertedFiles;
  };

  const uploadDocumentHandler = async () => {
    dispatch(isLoadingStateReducer(true));
    try {
      const allowedFileFormats = [
        "png",
        "jpg",
        "jpeg",
        "pdf",
        "heic",
        "heif",
        "webp",
        "mp3",
        "mp4",
        "wac",
        "aac",
        "docx",
        "tiff",
        "avi",
        "xlsx",
        "wav",
      ];
      let data = new FormData();
      let hasInvalidFile = false;

      for (let key in documentUpload) {
        const files = await fileConverter(documentUpload[key]);

        for (let file of files) {
          const fileExtension = file.name.split(".").pop().toLowerCase();
          if (!allowedFileFormats.includes(fileExtension)) {
            hasInvalidFile = true;
          }
          data.append(key.replace(/[\/\s]/g, ""), file);
        }

        if (hasInvalidFile) {
          break;
        }
      }

      if (hasInvalidFile) {
        dispatch(isLoadingStateReducer(false));
        showToast(
          `Invalid file format detected. Allowed formats are ${allowedFileFormats.join(
            ", "
          )}`,
          "error",
          true
        );
      } else {
        const response = await uploadDocument(caseId, data);
        if (response?.success) {
          dispatch(isLoadingStateReducer(false));
          showToast(response.message, "success", true);
          onSuccess();
        }
      }
    } catch (error) {
      dispatch(isLoadingStateReducer(false));
      showToast(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to upload document",
        "error",
        true
      );
    }
  };

  const dispatch = useDispatch();
  // convert fileSize
  const formatFileSize = function (bytes) {
    const sufixes = ["B", "kB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sufixes[i]}`;
  };

  const deleteFileHandler = (key, fileName) => {
    setUploadDocumentList((oldState) => {
      const modifiedData = { ...oldState };
      const fileList = modifiedData[key];
      if (fileList) {
        const updatedFileList = fileList.filter(
          (file) => file.fileName !== fileName
        );
        modifiedData[key] = updatedFileList;
        if (updatedFileList.length === 0) {
          delete modifiedData[key];
        }
        dispatch(documentUploadReducer(modifiedData));
        dispatch(deleteFile({ key, fileName })); // Dispatch the deleteFile action
      }
      return { ...modifiedData };
    });
  };

  const onchangeHandler = (e) => {
    setUploadDocumentList((oldState) => {
      let modifiedData = { ...oldState };
      const files = e?.target?.files;
      if (files.length > 0) {
        if (modifiedData[selectedValueUpload]?.length) {
          let uniqueFiles = Array.from(files)?.filter(
            (file) =>
              !modifiedData[selectedValueUpload].find(
                (obj) => obj?.fileName === file?.name
              )
          );
          modifiedData[selectedValueUpload] = [
            ...modifiedData[selectedValueUpload],
            ...Array.from(uniqueFiles).map((file) => ({
              fileName: file.name,
              fileUrl: URL.createObjectURL(file),
              fileSize: file.size,
            })),
          ];
        } else {
          modifiedData[selectedValueUpload] = Array.from(files).map((file) => ({
            fileName: file.name,
            fileUrl: URL.createObjectURL(file),
            fileSize: file.size,
          }));
        }
      }
      dispatch(documentUploadReducer(modifiedData));
      return modifiedData;
    });
  };

  useEffect(() => {
    setUploadDocumentList([]);
    dispatch(clearDocumentUopload());
  }, []);

  return (
    <>
      <h1 className={style.heading}>Upload Documents</h1>
      <div className={style["upload-conatiner"]}>
        <div className={style["customSelect_div"]}>
          <CustomSelect
            label={label}
            placeholder="Select"
            options={uploadOptions}
            sx={{ height: "4.2rem" }}
            customSelectValue={selectedValueUpload}
            handleChange={(e) => setSelectedValueUpload(e.target.value)}
          />
        </div>
        <div className={style["upload-images"]}>
          <CommonButton
            isUpload={selectedValueUpload !== "Select" ? true : false}
            disabled={selectedValueUpload?.length ? false : true}
            filledButton
            isAudioVideoUpload
            onChangeHandler={onchangeHandler}
            label={
              <FileUploadOutlinedIcon
                sx={{ fontSize: "2.9rem", color: "#FFFFFF" }}
              />
            }
          />
        </div>
      </div>
      {Object.keys(uploadDocumentList).map((key) => (
        <div key={key} className={style["map-conatiner"]}>
          {key.length > 0 && <h2>{key}</h2>}
          <div className={style["main-conatiner-div"]}>
            {Array.isArray(uploadDocumentList[key]) &&
              uploadDocumentList[key].map((doc, index) => (
                <div
                  key={`${key}-${index}-`}
                  className={style["file-conatiner"]}
                >
                  <div className={style["Uploadimage-div"]}>
                    <img src={AodbeIcon} alt="AodbeIcon" />
                    <div>
                      <p>{truncateMiddleText(doc?.fileName, 10)}</p>
                      <p className={style["fileSize"]}>
                        {formatFileSize(doc?.fileSize)}
                      </p>
                    </div>
                  </div>
                  <div
                    className={style["cancel-icon"]}
                    onClick={() => deleteFileHandler(key, doc?.fileName)}
                  >
                    <img src={CancelIcon} alt="cancel" />
                  </div>
                </div>
              ))}
          </div>
        </div>
      ))}
      <div className={style["button-div"]}>
        {Object.keys(uploadDocumentList)?.length ? (
          <CommonButton
            label={"Submit"}
            filledButton
            onClick={(e) => uploadDocumentHandler(e, uploadDocumentList)}
          />
        ) : null}
      </div>
    </>
  );
};

export default UploadDocument;
